import React, {useState} from 'react'
//---REDUX
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import allTheActions from '../actions'
import FormClub from "../components/formClub"
import Navbar from "../components/navbar"
import Menu from "../components/menu"
import TitleH1 from "../components/titleH1"
import {useHistory} from "react-router-dom";
import Popup from "../components/popupSwal";
//---

const CreateClub = props => {
    const history = useHistory()
    const [club, setClub] = useState({})
    const [file, setFile] = useState(null)

    const handleChangeFile = event => {
        setFile(event.target.files[0])
        setClub({...club, photo: event.target.files[0].name})
    }

    const handleChange = event => {
        setClub({...club, [event.target.name]: event.target.value})
    }

    const handleChangeRadio = event => {
        setClub({...club, affiliation: event})
    }

    const handleSubmit = async event => {
        event.preventDefault()

        if(club.photo === '' || club.photo === undefined) {
            alert("Vous n'avez pas ajouté de photo pour ce club")
            return
        }

        const fileData = new FormData()
        fileData.append('file', file)

        const newId = await props.actions.club.create(club)
        console.log(newId)
        if (newId) {
            if (await props.actions.club.photo(fileData, newId))
                Popup("Tout est good !", "Création du club réussie !", () => history.push('/clubs'))
        }
    }

    return (
        <div>
            <Navbar/>
            <Menu/>
            <TitleH1 content="Créer un club"/>
            <FormClub handleSubmit={handleSubmit}
                      handleChangeRadio={handleChangeRadio}
                      handleChangeFile={handleChangeFile}
                      handleChange={handleChange}
            />
        </div>
    )
}

const mapStateToProps = state => ({
    clubState: state.club
})

const mapDispatchToProps = () => dispatch => ({
    actions: {
        club: bindActionCreators(allTheActions.club, dispatch)
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(CreateClub)
